import { render } from "./AlunoComponent.vue?vue&type=template&id=d275ab74"
import script from "./AlunoComponent.vue?vue&type=script&lang=js"
export * from "./AlunoComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Prospecção Online\\Integracao.MatriculaOnline\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__